// `?capture` puts the site in recording mode for promo videos: auth prompts,
// toasts and other popups are hidden (anything marked data-capture-hide), the
// cursor and scrollbar are hidden, and time-based entrance animations are
// skipped so a given scroll position always renders the same frame.
// Read once at load because the app rewrites the URL as you navigate.
const params = new URLSearchParams(window.location.search);

export const CAPTURE = params.has('capture');
export const CAPTURE_THEME = params.get('theme') === 'light' ? 'light' : 'dark';

// Keeps the capture query string on in-app navigation.
export const captureSearch = CAPTURE ? window.location.search : '';
